import * as React from "react";
import { Fade } from "react-awesome-reveal";
import Container from "./styled";

export default function SeguroParaTodos() {
  return (
    <Container>
      {/* Max Width Container */}
      <Fade
        delay={100}
        duration={700}
        triggerOnce={true}
        className="maxWidthContainer"
      >
        {/* Title */}
        <h3>Seguros para todo</h3>
        {/* Text */}
        <p>
          Accedé a nuestra amplia variedad de Seguros y sus beneficios: viví
          tranquilo y al mejor precio con SeguroHogar. Protegé a tu fiel amigo
          con SeguroMascotas. Circulá acompañado por las coberturas más
          completas con SeguroMotos. Cuidá tu bienestar y el de tu familia con
          Salud Segura Online y asegurá tu patrimonio con los diversos Seguros
          que SeguroWeb tiene para vos (Seguro de Auto, Seguro de Camión, Seguro
          de Comercio, Seguro de Instrumentos Musicales y Seguro de Celular y
          otros dispositivos electrónicos).
        </p>
        {/* Seguros Images Container */}
        <div>
          {/* Seguro Logo */}
          <a href="https://www.seguromotos.com.ar/" target="_blank">
            <img
              alt="Logo Seguro Motos"
              src="images/logos/seguromotos.png"
              id="seguroMotos"
            ></img>
          </a>
          {/* Seguro Logo */}
          <a href="https://www.seguromascotas.com.ar//" target="_blank">
            <img
              alt="Logo Seguro Mascotas"
              src="images/logos/seguromascotas.png"
              id="seguroMascotas"
            ></img>
          </a>
          {/* Seguro Logo */}
          <a href="https://www.segurohogar.com.ar/" target="_blank">
            <img
              alt="Logo Seguro Hogar"
              src="images/logos/segurohogar.png"
              id="seguroHogar"
            ></img>
          </a>
          {/* Seguro Logo */}
          <a href="https://www.seguroweb.com.ar/" target="_blank">
            <img
              alt="Logo Seguro Web"
              src="images/logos/seguroweb.png"
              id="seguroWeb"
            ></img>
          </a>
          {/* Seguro Logo */}
          <a href="https://www.saludseguraonline.com.ar/" target="_blank">
            <img
              alt="Logo Salud Segura"
              src="images/logos/saludsegura.png"
              id="saludSegura"
            ></img>
          </a>
        </div>
      </Fade>
    </Container>
  );
}
